import React from "react";
import { Routes, Route, Link, useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import "@aws-amplify/ui-react/styles.css";
import "./App.css";
import { ThemeProvider } from "@aws-amplify/ui-react";
import theme from "./theme";
import Layout from "./components/Layout";
import Dashboard from "./pages/dashboard";
import Profile from "./pages/profile";
import Tables from "./pages/tables";
import UsersTable from "./pages/tables/UsersTablePage";
import Forms from "./pages/forms";
import EditForm from "./pages/forms/EditForm";
import Top5 from "./pages/top5";
import Usage from "./pages/usage";
import Conversations from "./pages/conversations";
import Users from "./pages/users";
import Aipreset from "./pages/aipreset";
import Chat from "./pages/chat";
import Aihub from "./pages/aihub";
import { useMyContext } from "./context/DataContext";
import History from "./pages/history";
import Newquery from "./pages/newquery";
import QANewProject from "./pages/qanewquery";
import KGChat from "./pages/chat/KGChat";
import OnboardingCopilot from "./pages/onboard-copilot/OnboardingCopilot";
import GenQADashboard from "./pages/qadashboard/GenQADashboard";
import DocumentFinder from "./pages/docfinder/DocFinder";
import { logError } from "./utils/errorHandling";
import ConsistencyGuard from "./pages/consguard/ConsistencyGuard";
import ConsGuardDashboard from "./pages/consguard-dashboard/ConsGuardDashboard";
import AdminDashboard from "./pages/admin-dashboard/AdminDashboard";
import Preaudit from "./pages/preaudit/Preaudit";
import NetworkErrorModal from "./components/NetworkErrorModal/NetworkErrorModal";
import { hasModule } from "./utils/moduleHelpers";
import { MODULES } from "./config/modules";



export default function App() {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const { updateState } = useMyContext()
  const location = useLocation();
  React.useEffect(() => {
    if (location.pathname === "/chat") {
      updateState("sideBar", "chatbar")
    }
  }, [location])

  // Ensure nothing renders until Auth0 resolves authentication
  React.useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      void loginWithRedirect().catch((error) => {
        logError("Auth redirect failed", error);
      });
    }
  }, [isAuthenticated, isLoading, loginWithRedirect]);

  // Show a loading screen until Auth0 state is resolved
  if (isLoading || (!isAuthenticated && !isLoading)) {
    return <div>Loading...</div>;
  }

  return (
    <ThemeProvider theme={theme}>
      <div>
        <NetworkErrorModal />
        <Routes>
          {/* All routes through a single routing structure */}
          <Route path="/" element={<Layout />}>
            {hasModule(MODULES.AI_HUB) && <Route index element={<Aihub />} />}
            {hasModule(MODULES.DASHBOARD) && <Route path="dashboard" element={<Dashboard />} />}
            <Route path="forms" element={<Forms />} />
            <Route path="edit-form" element={<EditForm />} />
            <Route path="tables" element={<Tables />} />
            <Route path="users-table" element={<UsersTable />} />
            <Route path="profile" element={<Profile />} />
            <Route path="top5" element={<Top5 />} />
            {hasModule(MODULES.USERS) && <Route path="users" element={<Users />} />}
            {hasModule(MODULES.USAGE) && <Route path="usage" element={<Usage />} />}
            {hasModule(MODULES.HISTORY) && <Route path="history" element={<History />} />}
            <Route path="conversations" element={<Conversations />} />
            <Route path="aipreset" element={<Aipreset />} />
            {hasModule(MODULES.AI_HUB) && <Route path="aihub" element={<Aihub />} />}
            {hasModule(MODULES.CHAT) && <Route path="chat" element={<Chat />} />}
            {hasModule(MODULES.ONBOARDING_COPILOT) && <Route path="onboard-copilot" element={<OnboardingCopilot />} />}
            {hasModule(MODULES.NL2GRAPH) && <Route path="newquery" element={<Newquery />} />}
            {hasModule(MODULES.QNA) && <Route path="qanewproject" element={<QANewProject />} />}
            {hasModule(MODULES.QNA) && <Route path="qanewproject/:projectName" element={<QANewProject />} />}
            {hasModule(MODULES.KG_CHAT) && <Route path="kgchat" element={<KGChat />} />}
            {hasModule(MODULES.QNA) && <Route path="qadashboard" element={<GenQADashboard />} />}
            {hasModule(MODULES.DOC_FINDER) && <Route path="docfinder" element={<DocumentFinder />} />}
            {hasModule(MODULES.CONSISTENCY_GUARD) && <Route path="consguard" element={<ConsistencyGuard />} />}
            {hasModule(MODULES.CONSISTENCY_GUARD) && <Route path="consguard-dashboard" element={<ConsGuardDashboard />} />}
            {hasModule(MODULES.AI_ADOPTION) && <Route path="admin-dashboard" element={<AdminDashboard />} />}
            <Route path="preaudit" element={<Preaudit />} />
            <Route path="*" element={<NoMatch />} />
          </Route>
        </Routes>


      </div>
    </ThemeProvider>
  );
}

function NoMatch() {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </div>
  );
}
